import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DynamicFormDto, DynamicPayloadDto } from '../../../../service/dto';
import { FormResult } from '../../dynamic-form.component';
import { AbstractDynamicForm, FormControlWrapper } from '../../dynamic-form-abstract';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpDynamicService } from '../../../../service/http-dynamic.service';

@Component({
	selector: 'app-dft-card',
	standalone: false,
	templateUrl: './dft-card.component.html',
	styleUrl: './dft-card.component.scss'
})
export class DftCardComponent extends AbstractDynamicForm implements OnInit, OnDestroy {
	@Input() title!: string;
	@Input() dynamicForm!: DynamicFormDto;
	@Input() readonly = false;
	@Input() masterForm?: FormGroup;
	@Input() allForms?: FormGroup[];
	@Input() allFormControls?: FormControlWrapper[];

	toControlKey = AbstractDynamicForm.toControlKey;

	displayTitle!: string
	form!: FormGroup;
	formControls!: FormControlWrapper[];
	formControlGrouped!: FormControlWrapper[][];
	vertical!: boolean;

	constructor(httpService: HttpDynamicService, private fb: FormBuilder, changeDetector: ChangeDetectorRef) {
		super(httpService, fb, changeDetector);
	}

	ngOnInit(): void {
		this.displayTitle = `${this.dynamicForm.id ? 'Create ' : 'Edit'} ${this.title}`;
		this.formControls = this.buildFormControls(this.dynamicForm);
		if (this.allFormControls) {
			this.allFormControls.push(...this.formControls);
		}

		this.form = this.buildForm(this.formControls);
		if (this.allForms) {
			this.allForms.push(this.form);
		}
		if (this.masterForm) {
			let name = this.title ?? ('Form: ' + (this.allForms ?? []).length);
			this.masterForm.addControl(name, this.form);
		}

		let maxLineNumber = this.formControls.map(item => item.element.lineNumber).filter(item => item != undefined).reduce((a, b) => Math.max(a, b), 1);

		this.formControlGrouped = Object.entries(
			this.formControls
				.filter(item => this.hasControl(this.form, item) && item.element.hidden == false)
				.reduce((groups, wrapper) => {
					const line = wrapper.element.lineNumber ?? (maxLineNumber++);
					if (!groups[line]) {
						groups[line] = [];
					}
					groups[line].push(wrapper);
					return groups;
				}, {} as Record<number, FormControlWrapper[]>)
		)
			.sort(([a], [b]) => Number(a) - Number(b))
			.map(([, wrappers]) => wrappers);
		for (let group of this.formControlGrouped) {
			console.log(`Group. ${group.length}`, group);
		}
		this.vertical = this.formControlGrouped.filter(item => item.length > 1).length > 0;
		console.log(`Vertical`,this.vertical);
	}
	ngOnDestroy(): void {
		this.formControls.forEach(item => item.subscription?.unsubscribe());
	}
}
